import "particles.js";
import particlesConfig from '../models/particle-config.json';

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin( ScrollToPlugin );

const Offset = 210;

function isMobile() {
    return window.matchMedia("( max-width: 767px )").matches;
}

export default ( object = {} ) => ( {
    Layers: null,
    videoSet: [],
    token: 'unset',
    currentToken: null,

    get isReady() {
        return !!this.Player;
    },

    returnDistributedPositionModifier(index, array) {
        let float = (array.length - ( index + 1 ) ) / array.length;
        return float;
    },

    setInitialOffsets() {
        let self = this;
        this.Layers.forEach( ( element, index, array ) => {
            let float = self.returnDistributedPositionModifier(index, array);
            // console.log( { float } );
            element.style.top = `${float * -Offset}px`;
        } );
    },

    init() {

        let self = this;

        this.Layers = [ ... this.$root.querySelectorAll( "[data-layer]" ) ];

        // console.log( "Envoy Poem", { object, "particles": window.particlesJS, 'debounce': Alpine.debounce, "Layers": this.Layers } );

        this.setInitialOffsets();

        // Particles
        // particlesJS.load( 'home-particle', 'https://assets.codepen.io/766734/particlesjs-config.json', function() {
        //     // console.log('callback - particles.js config loaded');
        // });
        particlesJS( 'home-particles', particlesConfig );

        // GSAP
        gsap.to( this.Layers, {
            y: function (index, target, targets) {
                var float = self.returnDistributedPositionModifier(index, targets);
                return float * Offset + "px";
            },
            scrollTrigger: {
                trigger: "#envoy-poem",
                start: "top 80%",
                end: "bottom 20%",
                // markers: true,
                toggleActions: "play pause reverse reset",
                scrub: true,
                pinSpacer: false
            }
        });
    }
} );
